import React from "react";
import style from "./Pricing.module.scss";
import Avatar from "../../../../components/Avatar/Avatar";
import HeadingWithLine from "../../../../components/HeadingWithLine/HeadingWithLine";
import visa from "../../../../../../images/v2/visa24x24.svg";
import master from "../../../../../../images/v2/master24x24.svg";
import discover from "../../../../../../images/v2/discover24x24.svg";
import amex from "../../../../../../images/v2/amex24x24.svg";
import useCommonStore from "../../../../stores/common";
import useMerchantStore from "../../../../stores/merchant";

function Pricing() {
  const expandDetails = useCommonStore((state) => state.expandDetails);
  const activeApp = useMerchantStore((state) => state.activeApp);
  const getPricingDataById = (id) => {
    let pricing = activeApp?.prices?.find((price) => price.id === id);
    return pricing ? pricing.pivot : { dollars: 0, percent: 0 };
  };

  const dualPricing = () => {
    return (
      <div
        className={`${style.cards} ${expandDetails ? style.expanded_cards : ""}`}
      >
        <div className={style.price_card}>
          <div className={style.pc_header}>
            <div className={style.pc_images}>
              <img src={visa} />
              <img src={master} />
              <img src={discover} />
            </div>
          </div>
          <div className={style.data_item_list}>
            <div className={style.data_item}>
              <p className={style.data_label}>Pricing Model</p>
              <p className={style.data_value}>Dual Pricing</p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}></p>
              <p className={style.data_value}></p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>Dual Pricing Rate</p>
              <p className={style.data_value}>
                {getPricingDataById(35).percent}%
              </p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>Monthly Fee</p>
              <p className={style.data_value}>
                $ {getPricingDataById(17).dollars}
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const surcharge = () => {
    return (
      <div
        className={`${style.cards} ${expandDetails ? style.expanded_cards : ""}`}
      >
        <div className={style.price_card}>
          <div className={style.pc_header}>
            <div className={style.pc_images}>
              <img src={visa} />
              <img src={master} />
              <img src={discover} />
            </div>
          </div>
          <div className={style.data_item_list}>
            <div className={style.data_item}>
              <p className={style.data_label}>Pricing Model</p>
              <p className={style.data_value}>Surcharge</p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>Rate</p>
              <p className={style.data_value}>
                {getPricingDataById(35).percent}%
              </p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>Per Txn</p>
              <p className={style.data_value}>
                $ {getPricingDataById(35).dollars}
              </p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>Monthly Fee</p>
              <p className={style.data_value}>
                $ {getPricingDataById(17).dollars}
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const flatRate = () => {
    return (
      <div
        className={`${style.cards} ${expandDetails ? style.expanded_cards : ""}`}
      >
        <div className={style.price_card}>
          <div className={style.pc_header}>
            <div className={style.pc_images}>
              <img src={visa} />
              <img src={master} />
              <img src={discover} />
            </div>
          </div>
          <div className={style.data_item_list}>
            <div className={style.data_item}>
              <p className={style.data_label}>Pricing Model</p>
              <p className={style.data_value}>Flat Rate</p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}></p>
              <p className={style.data_value}></p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>Rate</p>
              <p className={style.data_value}>
                {getPricingDataById(2).percent}%
              </p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>Txn Fee</p>
              <p className={style.data_value}>
                $ {getPricingDataById(2).dollars}
              </p>
            </div>
          </div>
        </div>

        <div className={style.price_card}>
          <div className={style.pc_header}>
            <div className={style.pc_images}>
              <img src={amex} />
            </div>
          </div>
          <div className={style.data_item_list}>
            <div className={style.data_item}>
              <p className={style.data_label}>Pricing Model</p>
              <p className={style.data_value}>Flat Rate</p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}></p>
              <p className={style.data_value}></p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>Rate</p>
              <p className={style.data_value}>
                {getPricingDataById(35).percent}%
              </p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>Txn Fee</p>
              <p className={style.data_value}>
                $ {getPricingDataById(35).dollars}
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const ICPlus = () => {
    return (
      <div
        className={`${style.cards} ${expandDetails ? style.expanded_cards : ""}`}
      >
        <div className={style.price_card}>
          <div className={style.pc_header}>
            <div className={style.pc_images}>
              <img src={visa} />
              <img src={master} />
              <img src={discover} />
            </div>
          </div>
          <div className={style.data_item_list}>
            <div className={style.data_item}>
              <p className={style.data_label}>Pricing Model</p>
              <p className={style.data_value}>IC+</p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}></p>
              <p className={style.data_value}></p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>Rate</p>
              <p className={style.data_value}>
                {getPricingDataById(2).percent}%
              </p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>Txn Fee</p>
              <p className={style.data_value}>
                $ {getPricingDataById(2).dollars}
              </p>
            </div>
          </div>
        </div>

        <div className={style.price_card}>
          <div className={style.pc_header}>
            <div className={style.pc_images}>
              <img src={amex} />
            </div>
          </div>
          <div className={style.data_item_list}>
            <div className={style.data_item}>
              <p className={style.data_label}>Pricing Model</p>
              <p className={style.data_value}>IC+</p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}></p>
              <p className={style.data_value}></p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>Rate</p>
              <p className={style.data_value}>
                {getPricingDataById(35).percent}%
              </p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>Txn Fee</p>
              <p className={style.data_value}>
                $ {getPricingDataById(35).dollars}
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const tiered = () => {
    return (
      <div
        className={`${style.cards} ${expandDetails ? style.expanded_cards : ""}`}
      >
        <div className={style.price_card}>
          <div className={style.pc_header}>
            <span>Qualified</span>
            <div className={style.pc_images}>
              <img src={visa} />
              <img src={master} />
              <img src={discover} />
            </div>
          </div>
          <div className={style.data_item_list}>
            <div className={style.data_item}>
              <p className={style.data_label}>Pricing Model</p>
              <p className={style.data_value}>Tiered</p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}></p>
              <p className={style.data_value}></p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>Qual Rate</p>
              <p className={style.data_value}>
                {getPricingDataById(1).percent}%
              </p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>Txn Fee</p>
              <p className={style.data_value}>
                $ {getPricingDataById(1).dollars}
              </p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>Debit Rate</p>
              <p className={style.data_value}>
                {getPricingDataById(39).percent}%
              </p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>Debit Per Txn</p>
              <p className={style.data_value}>
                $ {getPricingDataById(39).dollars}
              </p>
            </div>
          </div>
        </div>

        <div className={style.price_card}>
          <div className={style.pc_header}>
            <span>Mid-Qualified</span>
            <div className={style.pc_images}>
              <img src={visa} />
              <img src={master} />
              <img src={discover} />
            </div>
          </div>
          <div className={style.data_item_list}>
            <div className={style.data_item}>
              <p className={style.data_label}>Mid Qual Rate</p>
              <p className={style.data_value}>
                {getPricingDataById(3).percent}%
              </p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>Txn Fee</p>
              <p className={style.data_value}>
                $ {getPricingDataById(3).dollars}
              </p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>Debit Rate</p>
              <p className={style.data_value}>
                {getPricingDataById(40).percent}%
              </p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>Debit Per Txn</p>
              <p className={style.data_value}>
                $ {getPricingDataById(40).dollars}
              </p>
            </div>
          </div>
        </div>

        <div className={style.price_card}>
          <div className={style.pc_header}>
            <span>Non-Qualified</span>
            <div className={style.pc_images}>
              <img src={visa} />
              <img src={master} />
              <img src={discover} />
            </div>
          </div>
          <div className={style.data_item_list}>
            <div className={style.data_item}>
              <p className={style.data_label}>Non Qual Rate</p>
              <p className={style.data_value}>
                {getPricingDataById(4).percent}%
              </p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>Txn Fee</p>
              <p className={style.data_value}>
                $ {getPricingDataById(4).dollars}
              </p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>Debit Rate</p>
              <p className={style.data_value}>
                {getPricingDataById(41).percent}%
              </p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>Debit Per Txn</p>
              <p className={style.data_value}>
                $ {getPricingDataById(41).dollars}
              </p>
            </div>
          </div>
        </div>

        <div className={style.price_card}>
          <div className={style.pc_header}>
            <div className={style.pc_images}>
              <img src={amex} />
            </div>
          </div>
          <div className={style.data_item_list}>
            <div className={style.data_item}>
              <p className={style.data_label}>AMEX Pricing Model</p>
              <p className={style.data_value}>Tiered</p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}></p>
              <p className={style.data_value}></p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>Amex Tier 1</p>
              <p className={style.data_value}>
                {getPricingDataById(32).percent}%
              </p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>Txn Fee</p>
              <p className={style.data_value}>
                $ {getPricingDataById(32).dollars}
              </p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>Amex Tier 2</p>
              <p className={style.data_value}>
                {getPricingDataById(33).percent}%
              </p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>Txn Fee</p>
              <p className={style.data_value}>
                $ {getPricingDataById(33).dollars}
              </p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>Amex Tier 3</p>
              <p className={style.data_value}>
                {getPricingDataById(34).percent}%
              </p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>Txn Fee</p>
              <p className={style.data_value}>
                $ {getPricingDataById(34).dollars}
              </p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>Amex Tier 4</p>
              <p className={style.data_value}>
                {getPricingDataById(49).percent}%
              </p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>Txn Fee</p>
              <p className={style.data_value}>
                $ {getPricingDataById(49).dollars}
              </p>
            </div>
          </div>
        </div>

        <div className={style.price_card}>
          <div className={style.pc_header}>
            <div className={style.pc_images}>
              <img src={amex} />
            </div>
          </div>
          <div className={style.data_item_list}>
            <div className={style.data_item}>
              <p className={style.data_label}>AMEX Pricing Model</p>
              <p className={style.data_value}>Flat Rate</p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}></p>
              <p className={style.data_value}></p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>Rate</p>
              <p className={style.data_value}>
                {getPricingDataById(35).percent}%
              </p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>Txn Fee</p>
              <p className={style.data_value}>
                $ {getPricingDataById(35).dollars}
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className={style.pricing_tab}>
      <div className={style.rep}>
        <Avatar size="medium" name={activeApp?.user?.name?.charAt(0)} />
        <div className={style.rep_details}>
          <p className={style.rep_label}>Representative</p>
          <p className={style.rep_name}>
            {activeApp?.user?.name}
            <span className={style.rep_id}>
              {" "}
              | {activeApp?.user?.ems_rep_id || "-"}
            </span>{" "}
          </p>
        </div>
      </div>

      <div className={style.body}>
        <div
          className={`${style.pricing_structure} ${expandDetails ? style.expanded : ""}`}
        >
          <h5 className={style.heading}>Pricing structure</h5>
          <HeadingWithLine text={"Default Fees"} />
          <div className={style.data_item_list}>
            <div className={style.data_item}>
              <p className={style.data_label}>Setup fee</p>
              <p className={style.data_value}>
                $ {getPricingDataById(28).dollars}
              </p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>Monthly Access fee</p>
              <p className={style.data_value}>
                $ {getPricingDataById(19).dollars}
              </p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>$100k Data breadth</p>
              <p className={style.data_value}>
                $ {getPricingDataById(42).dollars}
              </p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>Monthly Minimum</p>
              <p className={style.data_value}>
                $ {getPricingDataById(18).dollars}
              </p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>Semi-annual tech fee</p>
              <p className={style.data_value}>
                $ {getPricingDataById(43).dollars}
              </p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>Voice ARU</p>
              <p className={style.data_value}>
                $ {getPricingDataById(12).dollars}
              </p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>Batch fee</p>
              <p className={style.data_value}>
                $ {getPricingDataById(14).dollars}
              </p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>Returned ACH item</p>
              <p className={style.data_value}>
                $ {getPricingDataById(22).dollars}
              </p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>AVS fee</p>
              <p className={style.data_value}>
                $ 1{getPricingDataById(13).dollars}
              </p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>3rd Party Auth/Txn</p>
              <p className={style.data_value}>
                $ 1{getPricingDataById(11).dollars}
              </p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>ETF fee</p>
              <p className={style.data_value}>
                $ {getPricingDataById(46).dollars}
              </p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>Chargeback fee</p>
              <p className={style.data_value}>
                $ {getPricingDataById(20).dollars}
              </p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>Representment fee</p>
              <p className={style.data_value}>
                $ {getPricingDataById(47).dollars}
              </p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>Pre-dispute fee</p>
              <p className={style.data_value}>
                $ {getPricingDataById(48).dollars}
              </p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>EBT Fee</p>
              <p className={style.data_value}>
                {getPricingDataById(29).dollars}
              </p>
            </div>
          </div>

          <HeadingWithLine text={"Pin-Based Debit"} />
          <div className={style.data_item_list}>
            <div className={style.data_item}>
              <p className={style.data_label}>Debit Rate</p>
              <p className={style.data_value}>
                {getPricingDataById(29).dollars}%
              </p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>Per Txn</p>
              <p className={style.data_value}>
                $ {getPricingDataById(29).percent}
              </p>
            </div>
          </div>
        </div>

        <div
          className={`${style.card_rates} ${expandDetails ? style.expanded : ""}`}
        >
          <h5 className={style.heading}>Card Rates</h5>

          {activeApp.qualifiedtype == "tiered" && tiered()}

          {activeApp.qualifiedtype == "dual_pricing" && dualPricing()}

          {activeApp.qualifiedtype == "surcharge" && surcharge()}

          {activeApp.qualifiedtype == "flat_rate" && flatRate()}
        </div>

        {/* <div className={style.pricing_structure} >
          <h5 className={style.heading} >Hardware</h5>
          <HeadingWithLine text={"Equipment"} line={false} />
          <div className={style.data_item_list} >
            <div className={style.data_item} >
              <p className={style.data_label} >Dejavoo QD4</p>
              <p className={style.data_value} >
                <span className={style.badge} >Purchase</span>
                $ 250.00 x2
              </p>
            </div>

            <div className={style.data_item} >
              <p className={style.data_label} >Valor VL500D</p>
              <p className={style.data_value} >
                <span className={style.badge} >Rent</span>
                $ 25.00/mo x20
              </p>
            </div>

            <div className={style.data_item} >
              <p className={style.data_label} >Dejavoo QD4</p>
              <p className={style.data_value} >
                <span className={style.badge} >Purchase</span>
                $ 350.00
              </p>
            </div>

            <div className={style.data_item} >
              <p className={style.data_label} >Dejavoo QD4</p>
              <p className={style.data_value} >
                <span className={style.badge} >TPP</span>
                $ 15.00/mo x2
              </p>
            </div>

            <div className={style.data_item} >
              <p className={style.data_label} >Valor VL500D</p>
              <p className={style.data_value} >
                <span className={style.badge} >Rent</span>
                $ 25.00/mo x20
              </p>
            </div>

          </div>
          <HeadingWithLine text={"Gateway"} />
          <div className={style.data_item_list} >
            <div className={style.data_item} >
              <p className={style.data_label} >Authorize.net</p>
              <p className={style.data_value} >
                $ 250.00
              </p>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
}

export default Pricing;
